import { Box, Grid, Heading, Image, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { EXAMPLES } from 'const';

export const PracticalExamples: React.FC = () => {
  return (
    <Box py={16}>
      <VStack>
        <VStack textAlign="center">
          <Heading size="xl">Praktiki Nümunələr</Heading>
          <Text fontSize="lg" color="gray.600" maxW="700px">
            Bütün platformalarda intuitiv interfeyslərə nəzər salın
          </Text>
        </VStack>

        <Grid
          templateColumns={{
            base: '1fr',
            md: 'repeat(2, 1fr)',
            lg: 'repeat(3, 1fr)'
          }}
          gap={6}
          w="100%"
        >
          {EXAMPLES.map((example, index) => (
            <VStack
              key={index}
              align="stretch"
              bg="white"
              borderRadius="xl"
              overflow="hidden"
              border="1px solid"
              borderColor="gray.200"
              transition="all 0.3s"
              _hover={{
                shadow: 'xl',
                transform: 'translateY(-4px)',
                borderColor: 'green.300'
              }}
            >
              <Box bg="gray.900" position="relative">
                <Image src={example.image} alt={example.title} objectFit={'cover'} w="100%" />
              </Box>

              <VStack align="start" p={6}>
                <Heading size="md" color="gray.800">
                  {example.title}
                </Heading>
                <Text color="gray.600" fontSize="sm">
                  {example.description}
                </Text>
              </VStack>
            </VStack>
          ))}
        </Grid>
      </VStack>
    </Box>
  );
};
